import { californiaHeaderLogo } from './California';
import { idahoHeaderLogo } from './Idaho';
import { minnesotaHeaderLogo } from './Minnesota';
import { nevadaHeaderLogo } from './Nevada';
import { newjersyHeaderLogo } from './NewJersy';
import { newmexicoHeaderLogo } from './NewMexico';
import { pennsylvaniaHeaderLogo } from './Pennsylvania';
import { georgiaHeaderLogo } from './Georgia';
import { virginiaHeaderLogo } from './Virginia';
import { illinoisHeaderLogo } from './Illinois';
import { getinsuredHeaderLogo } from './GetInsured';
import { IEX_STATE_CODES } from '@constants/configs/states';

export const headerLogoConfig = {
    [IEX_STATE_CODES.CA]: californiaHeaderLogo,
    [IEX_STATE_CODES.ID]: idahoHeaderLogo,
    [IEX_STATE_CODES.MN]: minnesotaHeaderLogo,
    [IEX_STATE_CODES.NV]: nevadaHeaderLogo,
    [IEX_STATE_CODES.NJ]: newjersyHeaderLogo,
    [IEX_STATE_CODES.NM]: newmexicoHeaderLogo,
    [IEX_STATE_CODES.PA]: pennsylvaniaHeaderLogo,
    [IEX_STATE_CODES.GA]: georgiaHeaderLogo,
    [IEX_STATE_CODES.VA]: virginiaHeaderLogo,
    [IEX_STATE_CODES.IL]: illinoisHeaderLogo,
    [IEX_STATE_CODES.GI]: getinsuredHeaderLogo
};